<template>
  <div>
    <Card>
      <Row class="operation">
        <Button @click="handleBack" icon="ios-arrow-back">返回</Button>
        <span style="margin-left: 12px; font-size: 14px; font-weight: 500">报名记录：{{ title }}</span>
      </Row>
      <br />
      <Table :loading="loading" border :columns="columns" :data="dataList"></Table>
      <div v-if="!loading && dataList.length === 0" style="text-align:center;padding:30px;color:#999">暂无报名记录</div>
    </Card>
  </div>
</template>

<script>
import { getJianzhangApplies } from '@/api/jianzhang.js'

export default {
  name: 'JianzhangApply',
  data () {
    return {
      loading: false,
      title: '',
      exid: null,
      dataList: [],
      columns: [
        { title: 'ID', key: 'id', width: 80 },
        { title: '报名人', key: 'user_name', minWidth: 120 },
        { title: 'UID', key: 'uid', width: 120 },
        { title: '岗位ID', key: 'jid', width: 90 },
        { title: '审核状态', key: 'auditText', width: 110, render: (h, params) => {
          const s = params.row.isaudit
          const map = { 0: ['待审核', 'warning'], 1: ['已通过', 'success'], 2: ['未通过', 'error'] }
          const pair = map[s] || ['待审核', 'warning']
          return h('Tag', { props: { color: pair[1] } }, pair[0])
        } },
        { title: '报名时间', key: 'apply_time', width: 170 },
        { title: '审核时间', key: 'audit_time', width: 170 },
        { title: '备注', key: 'remark', minWidth: 150, ellipsis: true }
      ]
    }
  },
  methods: {
    fetchApplies () {
      this.loading = true
      getJianzhangApplies(this.exid).then(res => {
        this.loading = false
        if (res.data.code === 0) {
          this.dataList = (res.data.data || []).map(item => {
            item.auditText = item
            return item
          })
        } else {
          this.$Message.error(res.data.msg || '获取失败')
        }
      }).catch(() => {
        this.loading = false
        this.$Message.error('请求失败')
      })
    },
    handleBack () {
      this.$router.push({ path: '/jianzhang/list' })
    }
  },
  created () {
    this.exid = Number(this.$route.params.id)
    this.fetchApplies()
  }
}
</script>

<style lang="less" scoped>
.operation {
  margin-bottom: 10px;
}
.operation .ivu-btn {
  margin-right: 8px;
}
</style>